__turbopack_context__.v({
  "className": "reckless_357dbf9e-module__AP6_aG__className",
  "variable": "reckless_357dbf9e-module__AP6_aG__variable",
});
